import { lazyFetchPoliciesAndSetStore } from 'owa-ocps-get-policies';
export { default as isOcpsPolicyEnabled } from './utils/isOcpsPolicyEnabled';
export { OcpsPolicy } from './utils/OcpsPolicy';

lazyFetchPoliciesAndSetStore.importAndExecute();
